"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makePid = void 0;
const makePid = () => {
    let text = '';
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for (let i = 0; i < 16; i += 1) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
};
exports.makePid = makePid;
